import { render, staticRenderFns } from "./ImagesManagementReject.vue?vue&type=template&id=c6ee2958&scoped=true&"
import script from "./ImagesManagementReject.vue?vue&type=script&lang=js&"
export * from "./ImagesManagementReject.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c6ee2958",
  null
  
)

export default component.exports